import { highLevelApi } from '@sdk/main'
import type { QueryPayload, CRMQueryPayload } from '@sdk/payload.types'

export function query(payload: QueryPayload) {
  return highLevelApi.API.request('query', payload)
}

export function crmQuery(payload: CRMQueryPayload): Promise<any> {
  return highLevelApi.API.request('crm_query', payload)
}
